enum PreviewMode {
  Mobile = 'mobile',
  Web = 'web'
}

export default PreviewMode;
